
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { login } from '../service/getdata'
import areaList from '../components/areaList.vue'
export default {
components: {
XHeader,
Toast,
areaList
},
data() {
return {
icon: "", //选中国家的图标
dialCode: 1, //选中国家的区号
type: 2, //登录类型。1:账号 2邮箱 3手机号
username: "", //登录名
password: "", //密码
msg: "", //提示框内容
show: false, //提示框是否提示
input_type: 'password' 
}
},
created() {
this.username = window.sessionStorage.getItem('username') || ''
this.password = window.sessionStorage.getItem('password') || ""
},
computed:{
...mapState(['url'])
},
methods: {
...mapMutations(['SETTOKEN']),

getName (params) {
this.icon = params.code;
this.dialCode = params.dialCode;
},
onSelectArea ()  {
this.$refs.controlChildRef.open();
},

login() {
const that = this;
if(!this.username || this.username == ''){
this.sendMsg(this.$t('请输入登录账号'))
return
}

if(this.password == ''){
this.sendMsg(this.$t('请输入登录密码'))
return
}
this.$Loading()
login({mobile: this.username, password: this.password,type: this.type, country_code: this.dialCode}).then(function (res) {
var res = res.data;
that.$Loading.close()
if (res.status=='1') {
window.sessionStorage.setItem('username', that.username)
window.sessionStorage.setItem('password', that.password)
that.SETTOKEN(res.data.token);
window.localStorage.setItem('uid',res.data.uid)
that.$router.push('/pages/home/quotes')
} else {
that.sendMsg(res.message)
}
}.bind(this), function (error) {
that.$Loading.close()
that.sendMsg(that.$t('登录失败'))
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
}
}
}



// WEBPACK FOOTER //
// ./src/pages/login.vue